module.exports = __webpack_public_path__ + "img/ic-rain.fa58ac79.svg";